import *as React from 'react';
import { RouteComponentProps, Route, Redirect } from "react-router-dom";
import { getCurrentUser } from '../../services/selectors/Accounts';

interface IRouteProps{
	component: RouteComponentProps;
	path: string;
	exact?: boolean;
	roles?: string[];
}

const AuthRoute: React.SFC<IRouteProps> = ({ component: Component, path, exact = false, roles = [] }) => {
	const isAuthed = true;
	const user = getCurrentUser();
	const requiredRoles = roles.some(r => user.info.roleCodes.indexOf(r) >= 0)
	const message = requiredRoles ? "Please login" : "unauthorised";
	return (
		<Route exact={exact} path={path} render={(props: RouteComponentProps) =>
			isAuthed && requiredRoles ? <Component {...props} /> :
				<Redirect
					to={{
						pathname: requiredRoles ? "/" : path != "/front" ? "/401" :'/unauth',
						state: { message, requestedPath: path }
					}} />
		} />
	)
};
export default AuthRoute;